import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RegisterCountryManufactureComponent} from "./register-country-manufacture.component";

const routes: Routes = [
  {path: '', component: RegisterCountryManufactureComponent},
  {path: ':id', component: RegisterCountryManufactureComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegisterCountryManufactureRoutingModule { }
